import domainFn from './defence';
const NODE_ENV = process.env.REACT_APP_ENV;
const envConfig: string | undefined = process.env.NODE_ENV === 'development' ? 'test' : NODE_ENV; // 开发环境  和  发布环境
let proxyCurrent: any = []; // 当前代理环境
let wsUrl: string = ''; // webSocket当前环境域名
let showApiDomain = ''; // 96show 业务 API 直连域名（test-api 等）
let showPayApiDomain = ''; // 996hezi 白名单 /payApi 路径解析目标（pay-api*.96show.com）
let showPcApiDomain = ''; // 996hezi 白名单 /pcApi 路径解析目标（pc-api*.96show.com）
// 代理到域名
// const proxyLists = [
//   { prefix: '/test', target: 'http://pcclient-dev.dhsf.xqhuyu.com' },
//   { prefix: '/pre', target: 'http://pc-pre.996box.com' },
//   { prefix: '/online', target: 'https://pc.996box.com' }
// ]

// 公共环境
const publicApiTargets = [
  { prefix: '/videoApi', target: '//192.168.10.170:10780' } // 短视频
];
// 测试环境 test
const testApiTargets = [
  { prefix: '/userApi', target: `//user-api-dev.${domainFn.domain}` }, // 用户
  { prefix: '/payApi', target: `//pay-api-dev.${domainFn.domain}` }, // 充值
  { prefix: '/pcApi', target: `//pc-api-dev.${domainFn.domain}` }, // 内容
  { prefix: '/chargeApi', target: `//charge-api-dev.${domainFn.domain}` }, // 交易行
  { prefix: '/forumApi', target: `//forum-api-dev.${domainFn.domain}` }, // 社区
  { prefix: '/footprintApi', target: `//footprint-api-dev.${domainFn.domain}` }, // 社区埋点 直播埋点
  { prefix: '/liveApi', target: `//live-api-dev.${domainFn.domain}` }, // 直播
  { prefix: '/tgdataApi', target: `//yyht-api-dev.${domainFn.domain}/uploads` }, // 赛事
  { prefix: '/authApi', target: `//test-api.${domainFn.domain}` }, // 身份认证
  { prefix: '/authApis', target: 'ws://10.41.0.25:11980' }, // 身份认证
  { prefix: '/jyhApi', target: `//charge-api-dev.${domainFn.domain}` }, // 交易行
  { prefix: '/boxCollectApi', target: `//box-collect-dev.${domainFn.domain}` }, // 盒子新埋点收集
  { prefix: '/uploadsApi', target: `//uploads-api-dev.${domainFn.domain}` }, // 图片上传
  { prefix: '/postColletApi', target: '//collect-dev.dhsf.xqhuyu.com' }, // 社区埋点
  { prefix: '/collectApi', target: '//collect-dev.dhsf.xqhuyu.com' } // 数据收集
];

// 旧测试环境 test
// const testApiTargets = [
//   { prefix: '/userApi', target: 'http://boxuser-dev.dhsf.xqhuyu.com' }, // 用户
//   { prefix: '/payApi', target: 'http://boxp-content-dev.dhsf.xqhuyu.com' }, // 充值
//   { prefix: '/pcApi', target: 'http://pc-content-dev.dhsf.xqhuyu.com' }, // 内容
//   { prefix: '/chargeApi', target: 'http://charge-api-test.996box.com' }, // 交易行
//   { prefix: '/forumApi', target: 'http://comment.dhsftest.xqhuyu.com' }, // 社区
//   { prefix: '/footprintApi', target: 'http://anvj.dhsftest.xqhuyu.com' }, // 社区埋点 直播埋点
//   { prefix: '/liveApi', target: 'http://live-dev.996box.com' }, // 直播
//   { prefix: '/tgdataApi', target: 'http://boxmanagerht-api-dev.dhsf.xqhuyu.com/uploads' }, // 赛事
//   { prefix: '/authApi', target: 'http://test-api.dhsf.xqhuyu.com' }, // 身份认证
//   { prefix: '/jyhApi', target: 'http://charge-api-test.996box.com' }, // 交易行
//   { prefix: '/boxCollectApi', target: 'http://box-collect.dev.xqhuyu.com' } // 盒子新埋点收集
// { prefix: '/uploadsApi', target: '//uploads.996box.com' }, // 图片上传
// ];
// 准生产环境 pre
const preApiTargets = [
  { prefix: '/userApi', target: `//user-api-pre.${domainFn.domain}` }, // 用户
  { prefix: '/windowApi', target: `//pre-api.${domainFn.domain}` }, // 新窗口内用户
  { prefix: '/payApi', target: `//pay-api-pre.${domainFn.domain}` }, // 充值
  { prefix: '/pcApi', target: `//pc-api-pre.${domainFn.domain}` }, // 内容
  { prefix: '/chargeApi', target: `//charge-api-pre.${domainFn.domain}` }, // 交易行
  { prefix: '/forumApi', target: `//forum-api-pre.${domainFn.domain}` }, // 社区
  { prefix: '/footprintApi', target: `//footprint-api-pre.${domainFn.domain}` }, // 社区埋点 直播埋点
  { prefix: '/liveApi', target: `//live-api-pre.${domainFn.domain}` }, // 直播
  { prefix: '/tgdataApi', target: `//tgdata.${domainFn.domain}` }, // 赛事
  { prefix: '/authApi', target: `//pre-api.${domainFn.domain}` }, // 身份认证
  { prefix: '/jyhApi', target: `//charge-api-pre.${domainFn.domain}` }, // 交易行
  { prefix: '/boxCollectApi', target: `//box-collect-pre.${domainFn.domain}` }, // 盒子新埋点收集
  { prefix: '/uploadsApi', target: `//uploads.${domainFn.domain}` }, // 图片上传
  { prefix: '/postColletApi', target: '//collect-dev.dhsf.xqhuyu.com' }, // 社区埋点
  { prefix: '/collectApi', target: '//collect-pre.dhsf.xqhuyu.com' } // 数据收集
];
// 线上环境 online
const onlineApiTargets = [
  { prefix: '/userApi', target: `https://user-api.${domainFn.domain}` }, // 用户
  { prefix: '/payApi', target: `https://pay-api.${domainFn.domain}` }, // 充值
  { prefix: '/pcApi', target: `https://pc-api.${domainFn.domain}` }, // 内容
  { prefix: '/chargeApi', target: `https://charge-api.${domainFn.domain}` }, // 交易行
  { prefix: '/forumApi', target: `https://forum-api.${domainFn.domain}` }, // 社区
  { prefix: '/footprintApi', target: `https://footprint.${domainFn.domain}` }, // 社区埋点 直播埋点
  { prefix: '/liveApi', target: `https://live-api.${domainFn.domain}` }, // 直播
  { prefix: '/tgdataApi', target: `//tgdata.${domainFn.domain}` }, // 赛事
  { prefix: '/authApi', target: `https://api.${domainFn.domain}` }, // 身份认证
  { prefix: '/jyhApi', target: `//charge-api.${domainFn.domain}` }, // 交易行
  { prefix: '/boxCollectApi', target: `https://box-collect.${domainFn.domain}` }, // 盒子新埋点收集
  { prefix: '/uploadsApi', target: `//uploads.${domainFn.domain}` }, // 图片上传
  { prefix: '/postColletApi', target: '//collect.dhsf.xqhuyu.com' }, // 社区埋点
  { prefix: '/collectApi', target: '//collect.dhsf.xqhuyu.com' } // 数据收集
];
// 压测环境
const petApiTargets = [
  { prefix: '/userApi', target: `https://user-api-pet.box.hqyxkj.cn` }, // 用户
  { prefix: '/payApi', target: `https://pay-api-pet.box.hqyxkj.cn` }, // 充值
  { prefix: '/pcApi', target: `https://pc-api-pet.box.hqyxkj.cn` }, // 内容
  { prefix: '/chargeApi', target: `https://charge-api-pet.box.hqyxkj.cn` }, // 交易行
  { prefix: '/forumApi', target: `https://forum-api-pet.box.hqyxkj.cn` }, // 社区
  { prefix: '/footprintApi', target: `https://footprint-pet.box.hqyxkj.cn` }, // 社区埋点 直播埋点
  { prefix: '/liveApi', target: `https://live-api-pet.box.hqyxkj.cn` }, // 直播
  { prefix: '/tgdataApi', target: `//tgdata-pet.box.hqyxkj.cn` }, // 赛事
  { prefix: '/authApi', target: `https://pet-api.box.hqyxkj.cn` }, // 身份认证
  { prefix: '/jyhApi', target: `//charge-api-pet.box.hqyxkj.cn` }, // 交易行
  { prefix: '/boxCollectApi', target: `https://box-collect-pet.box.hqyxkj.cn` }, // 盒子新埋点收集
  { prefix: '/uploadsApi', target: `//uploads-pet.box.hqyxkj.cn` }, // 图片上传
  { prefix: '/postColletApi', target: '//collect-pet.box.hqyxkj.cn' } // 社区埋点
];

let initDomain: string[] = [];
// 当前环境
if (envConfig === 'development') {
  proxyCurrent = [...testApiTargets, ...publicApiTargets]; // 开发环境
  wsUrl = `wss://test-ws.${domainFn.domain}`;
  initDomain = ['test-api.hzzhxy.cn', 'test-api.zzhhxy.cn'];
  showApiDomain = '//test-api.96show.com';
  showPayApiDomain = '//pay-api-dev.96show.com';
  showPcApiDomain = '//pc-api-dev.96show.com';
}
if (envConfig === 'test') {
  if (localStorage.getItem('appv') && localStorage.getItem('appv') === '4.7.3') {
    proxyCurrent = [...petApiTargets, ...publicApiTargets]; // 压测环境
    wsUrl = `wss://test-api.996box.com`;
    initDomain = ['test-api.hzzhxy.cn', 'test-api.zzhhxy.cn'];
  } else {
    proxyCurrent = [...testApiTargets, ...publicApiTargets]; // 测试环境
    wsUrl = `wss://test-ws.${domainFn.domain}`;
    initDomain = ['test-api.hzzhxy.cn', 'test-api.zzhhxy.cn'];
  }
  showApiDomain = '//test-api.96show.com';
  showPayApiDomain = '//pay-api-dev.96show.com';
  showPcApiDomain = '//pc-api-dev.96show.com';
}
if (envConfig === 'pre') {
  proxyCurrent = [...preApiTargets, ...publicApiTargets]; // 准生产环境
  wsUrl = `wss://pre-ws.${domainFn.domain}`;
  initDomain = ['pre-api.hzzhxy.cn', 'pre-api.zzhhxy.cn'];
  showApiDomain = '//pre-api.96show.com';
  showPayApiDomain = '//pay-api-pre.96show.com';
  showPcApiDomain = '//pc-api-pre.96show.com';
}
if (envConfig === 'production') {
  proxyCurrent = [...onlineApiTargets, ...publicApiTargets]; // 正式环境
  wsUrl = `wss://ws.${domainFn.domain}`;
  initDomain = ['api.hzzhxy.cn', 'api.zzhhxy.cn'];
  showApiDomain = 'https://api.96show.com';
  showPayApiDomain = 'https://pay-api.96show.com';
  showPcApiDomain = 'https://pc-api.96show.com';
}

const Config = { envConfig, proxyCurrent, initDomain, showApiDomain, showPayApiDomain, showPcApiDomain };

export default Config;
export const Websocket_key = wsUrl;
